import './bootstrap';

import Publication from './pages/publication';
import Content from './pages/content';
import Summary from './pages/summary';
import 'dropify';
import './default';
import './wwdev/PreventSubmit/index.js';

$( document ).ready(function() {
	new Publication();
	new Content();
	new Summary();

	$('body').on('click', '.openBootstrapModal', function (){
		$('.modal-body').load($(this).data('href'),function(){
			$('#bootstrapModal').modal({show:true});
		});
	});
    jQuery.each( [ "put", "delete" ], function( i, method ) {
        jQuery[ method ] = function( url, data, callback, type ) {
            if ( jQuery.isFunction( data ) ) {
                type = type || callback;
                callback = data;
                data = undefined;
            }

            return jQuery.ajax({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            });
        };
    });
	$('.dropify').dropify({
		messages: {
			'default': 'Sleep uw bestand hiernaartoe of klik om te zoeken',
			'replace': 'Klik om te vervangen',
			'remove': 'Verwijderen',
			'error': 'Er is iets misgegaan.'
		},
		error: {
			fileSize: "Het bestand is te groot ({{ value }} max).",
			minWidth: "De afbeelding is te smal ({{ value }}}px min).",
			maxWidth: "De afbeelding is te breed ({{ value }}}px max).",
			minHeight: "De afbeelding is niet hoog genoeg ({{ value }}}px min).",
			maxHeight: "De afbeelding is te hoog ({{ value }}px max).",
			imageFormat: "Het bestandsformaat is niet toegestaan (Toegestaan: {{ value }} ).",
			fileExtension: "Het bestandsformaat is niet toegestaan (Toegestaan: {{ value }} )."
		},
		maxFileSize: "25M"
	});
});

